
import { call, put, takeLatest } from 'redux-saga/effects';
import { SHIPPER_INFOR, SHIPPER_INFOR_FAILS, SHIPPER_INFOR_SUCCESS } from './../actions/shipperInfor';
import hanldeException from './../services/handleException';
import { shipperInfor } from './../utils/shipperInfor';

export function* shipperInforSaga() {
    yield takeLatest(SHIPPER_INFOR, shipperInforHandle)
}

function* shipperInforHandle(data) {
    try {
        const response = yield call(shipperInfor, data.payload)

        if (response.data.code === 10001) {
            yield put({ type: SHIPPER_INFOR_SUCCESS, payload: response })
        } else {
            yield put({ type: SHIPPER_INFOR_FAILS, payload: response })
            hanldeException(response)
        }
    } catch (error) {
        yield put({ type: SHIPPER_INFOR_FAILS, error })
        hanldeException(error)
    }
}

export default shipperInforSaga


// WEBPACK FOOTER //
// ./src/sagas/shipperInforSaga.js